export default "__VITE_ASSET__o3_VlE9a__"